import React from "react";

import { CtgListData } from "@/components/business/CtgListContainer/ctgList.types";
import { DRAFT_STATUS_INFO } from "@PressListContainer/draftStatusInfo.constants";
import { checkUrlStatus } from "@utils/checkUrlStatus";

import * as S from "./CtgStatus.style";

interface Props {
  data: CtgListData;
  isDraftError: boolean;
  draftErrorMessage: string;
  disabled: boolean;
  createDAE: (id: number) => void;
}

const EFORTLESS_URL_PROD = "https://bio-research.ai";
const EFORTLESS_URL_DEV = "https://bio-research.dev";
const EFORTLESS_URL_LOCAL = "http://localhost:3000";

const REDIRECT_URL_ACCORDING_TO_URL_STATUS = {
  PROD: EFORTLESS_URL_PROD,
  DEV: EFORTLESS_URL_DEV,
  LOCAL: EFORTLESS_URL_LOCAL,
};

const handleOpenArticle = (urlTitle?: string | null) => {
  const urlStatus = checkUrlStatus();

  if (!urlTitle) return;

  return window.open(
    `${REDIRECT_URL_ACCORDING_TO_URL_STATUS[urlStatus]}/${urlTitle}`,
    "_blank",
  );
};

const CtgStatus = ({
  data,
  isDraftError,
  draftErrorMessage,
  disabled,
  createDAE,
}: Props) => {
  if (isDraftError) {
    return (
      <S.StatusIcon className="draft-system-error" code={null}>
        <img
          src={DRAFT_STATUS_INFO.SystemError.icon}
          alt={DRAFT_STATUS_INFO.SystemError.text}
        />
        <S.StatusTooltip className="tooltip">
          {`System Error / ${draftErrorMessage}`}
        </S.StatusTooltip>
      </S.StatusIcon>
    );
  } else {
    switch (data.draftArticleStatusHighest) {
      // case "S110":
      // case "S121":
      // case "S911":
      // case "S210":
      // case "S220":
      case "S112": // not for ai entry
        return (
          <S.StatusIcon
            code={data.draftArticleStatusHighest}
            onClick={() => createDAE(data?.id)}
            disabled={disabled}
          >
            <img
              src={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].icon}
              alt={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            />
            <S.StatusTooltip className="tooltip">
              <span>
                {`${DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}\n`}
                <b>(Click to Apply DAE)</b>
              </span>
            </S.StatusTooltip>
          </S.StatusIcon>
        );
      case "S300": // progress
      case "S120": // review in progress
      case "S910": // db saved
        return (
          <S.StatusIcon code={data.draftArticleStatusHighest}>
            <img
              src={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].icon}
              alt={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            />
            <S.StatusTooltip className="tooltip">
              {DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            </S.StatusTooltip>
          </S.StatusIcon>
        );
      case "S912": // completed
        return (
          <S.StatusIcon code={data.draftArticleStatusHighest}>
            <img
              src={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].icon}
              alt={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            />
            <S.StatusTooltip className="tooltip">
              {DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            </S.StatusTooltip>
          </S.StatusIcon>
        );
      case "S920":
        return (
          <S.StatusIcon
            code={data.draftArticleStatusHighest}
            onClick={() => handleOpenArticle(data?.registryUrl)}
          >
            <img
              src={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].icon}
              alt={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            />
            <S.StatusTooltip className="tooltip">
              {DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            </S.StatusTooltip>
          </S.StatusIcon>
        );
      case "S930": // unsuitable
        return (
          <S.StatusIcon code={data.draftArticleStatusHighest}>
            <img
              src={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].icon}
              alt={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            />
            <S.StatusTooltip className="tooltip">
              {["Unsuitable", data.articleRejectReason]
                .filter((item) => !!item)
                .join(" / ")}
            </S.StatusTooltip>
          </S.StatusIcon>
        );
      case "S111": // ai done
        return (
          <S.StatusIcon
            code={data.draftArticleStatusHighest}
            onClick={() => createDAE(data?.id)}
            disabled={disabled}
          >
            <img
              src={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].icon}
              alt={DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}
            />
            <S.StatusTooltip className="tooltip">
              <span>
                {`${DRAFT_STATUS_INFO[data.draftArticleStatusHighest].text}\n`}
                <b>(Click to Apply DAE)</b>
              </span>
            </S.StatusTooltip>
          </S.StatusIcon>
        );
      default:
        return null;
    }
  }
};

export default CtgStatus;
